import { modelConfigs } from "@/lib/models";
import { SectionTitle } from "./SectionTitle";
import { ModelThumbnail } from "./ModelThumbnail";
import { useTranslation } from "@/lib/i18n";

interface ModelSectionProps {
  selectedModel: string;
  onModelChange: (model: string) => void;
}

export const ModelSection = ({
  selectedModel,
  onModelChange,
}: ModelSectionProps) => {
  const t = useTranslation();

  return (
    <div className="p-4">
      <SectionTitle title={t.sections.model} />
      <div className="flex gap-1.5">
        {modelConfigs.map((model) => (
          <ModelThumbnail
            key={model.id}
            model={model}
            selected={model.id === selectedModel}
            onClick={() => onModelChange(model.id)}
          />
        ))}
      </div>
    </div>
  );
};
